import { CreateNamedRangesProgressiveEnhancement, ProgressiveEnhancementRuleMap } from "../services/progressiveEnhancement";

export const progressiveEnhancementRules: Record<string, ProgressiveEnhancementRuleMap> = {
    "ReviewToolingTest": {
        "M25_RENTAL_PROPERTY": [
            {
                type: 'create-named-range',
                inputs: {
                    ranges: {
                        'M25_GrossRent_2': {
                            address: 'C10',
                            comment: 'Created by Auto Coach'
                        }
                    }
                }
            } satisfies CreateNamedRangesProgressiveEnhancement
        ]
    }
};
